import $ from 'jquery'
window.$ = window.jQuery = $

import * as stopword from 'stopword'
window.stopword = stopword

import './ThirdParty/extendStopWords.js'

